import { handleActions } from 'redux-actions';
import { AuthState, RootState } from '../../../types';
import authActions from './actions';

export default handleActions<AuthState, string>(
  {
    [authActions.logInSuccess.toString()]: (state, action) => ({
      userToken: action.payload
    })
  },
  { userToken: '' }
);

export const getUserToken = (state: RootState) => state.app.auth.userToken;

export const getIsAuthenticated = (state: RootState) =>
  !!state.app.auth.userToken;
